
export const replaceRange = (s, start, end, substitute) => {
	return s.substring(0, start) + substitute + s.substring(end);
}
const arrLetters = [
	'a',
	'b',
	'c',
	'd',
	'e',
	'f',
	'g',
	'h',
	'i',
	'j',
	'k',
	'l',
	'm',
	'n',
	'o',
	'p',
	'k',
	'r',
	's',
	't',
	'u',
	'v',
	'w',
	'x',
	'y',
	'z',
	'1',
	'2',
	'3',
	'4',
	'5',
	'6',
	'7',
	'8',
	'9',
	'0',
	'A',
	'B',
	'C',
	'D',
	'E',
	'F',
	'G',
	'H',
	'I',
	'J',
	'K',
	'L',
	'M',
	'N',
	'O',
	'P',
	'Q',
	'R',
	'S',
	'T',
	'U',
	'V',
	'X',
	'Y',
	'Z',
	'á',
	'é',
	'í',
	'ó',
	'ú',
	'Á',
	'É',
	'Í',
	'Ó',
	'Ú',
	'ü',
	'Ü'
]
// arrLetters.forEach((letter)=>{
// 	arrLetters.letter[0];
// })
const arrLettersBold =
{
	'a': [
		"𝗮",
		"𝘢",
		"𝙖"
	],
	'b': [
		"𝗯",
		"𝘣",
		"𝙗"
	],
	'c': [
		"𝗰",
		"𝘤",
		"𝙘"
	],
	'd': [
		"𝗱",
		"𝘥",
		"𝙙"
	],
	'e': [
		"𝗲",
		"𝘦",
		"𝙚"
	],
	'f': [
		"𝗳",
		"𝘧",
		"𝙛"
	],
	'g': [
		"𝗴",
		"𝘨",
		"𝙜"
	],
	'h': [
		"𝗵",
		"𝘩",
		"𝙝"
	],
	'i': [
		"𝗶",
		"𝘪",
		"𝙞"
	],
	'j': [
		"𝗷",
		"𝘫",
		"𝙟"
	],
	'k': [
		"𝗸",
		"𝘬",
		"𝙠"
	],
	'l': [
		"𝗹",
		"𝘭",
		"𝙡"
	],
	'm': [
		"𝗺",
		"𝘮",
		"𝙢"
	],
	"n": [
		"𝗻",
		"𝘯",
		"𝙣"
	],
	"o": [
		"𝗼",
		"𝘰",
		"𝙤"
	],
	"p": [
		"𝗽",
		"𝑝",
		"𝙥"
	],
	"q": [
		"𝗾",
		"𝘲",
		"𝙦"
	],
	"r": [
		"𝗿",
		"𝘳",
		"𝙧"
	],
	"s": [
		"𝘀",
		"𝘴",
		"𝙨"
	],
	"t": [
		"𝘁",
		"𝘵",
		"𝙩"
	],
	"u": [
		"𝘂",
		"𝘶",
		"𝙪"
	],
	"v": [
		"𝘃",
		"𝘷",
		"𝙫"
	],
	"w": [
		"𝘄",
		"𝘸",
		"𝙬"
	],
	"x": [
		"𝘅",
		"𝘹",
		"𝙭"
	],
	"y": [
		"𝘆",
		"𝘺",
		"𝙮"
	],
	"z": [
		"𝘇",
		"𝘻",
		"𝙯"
	],
	"1": [
		"𝟭",
		"1",
		"1"
	],
	"2": [
		"𝟮",
		"2",
		"2"
	],
	"3": [
		"𝟯",
		"3",
		"3"
	],
	"4": [
		"𝟰",
		"4",
		"4"
	],
	"5": [
		"𝟱",
		"5",
		"5"
	],
	"6": [
		"𝟲",
		"6",
		"6"
	],
	"7": [
		"𝟳",
		"7",
		"7"
	],
	"8": [
		"𝟴",
		"8",
		"8"
	],
	"9": [
		"𝟵",
		"9",
		"9"
	],
	"0": [
		"𝟬",
		"0",
		"0"
	],
	"A": [
		"𝗔",
		"𝘈",
		"𝘼"
	],
	"B": [
		"𝗕",
		"𝘉",
		"𝘽"
	],
	"C": [
		"𝗖",
		"𝘊",
		"𝘾"
	],
	"D": [
		"𝗗",
		"𝘋",
		"𝘿"
	],
	"E": [
		"𝗘",
		"𝘌",
		"𝙀"
	],
	"F": [
		"𝗙",
		"𝘍",
		"𝙁"
	],
	"G": [
		"𝗚",
		"𝘎",
		"𝙂"
	],
	"H": [
		"𝗛",
		"𝘏",
		"𝙃"
	],
	"I": [
		"𝗜",
		"𝘐",
		"𝙄"
	],
	"J": [
		"𝗝",
		"𝘑",
		"𝙅"
	],
	"K": [
		"𝗞",
		"𝘒",
		"𝙆"
	],
	"L": [
		"𝗟",
		"𝘓",
		"𝙇"
	],
	"M": [
		"𝗠",
		"𝘔",
		"𝙈"
	],
	"N": [
		"𝗡",
		"𝘕",
		"𝙉"
	],
	"O": [
		"𝗢",
		"𝘖",
		"𝙊"
	],
	"P": [
		"𝗣",
		"𝘗",
		"𝙋"
	],
	"Q": [
		"𝗤",
		"𝘘",
		"𝙌"
	],
	"R": [
		"𝗥",
		"𝘙",
		"𝙍"
	],
	"S": [
		"𝗦",
		"𝘚",
		"𝙎"
	],
	"T": [
		"𝗧",
		"𝘛",
		"𝙏"
	],
	"U": [
		"𝗨",
		"𝘜",
		"𝙐"
	],
	"V": [
		"𝗩",
		"𝘝",
		"𝙑"
	],
	"W": [
		"𝗪",
		"𝘞",
		"𝙒"
	],
	"X": [
		"𝗫",
		"𝘟",
		"𝙓"
	],
	"Y": [
		"𝗬",
		"𝘠",
		"𝙔"
	],
	"Z": [
		"𝗭",
		"𝘡",
		"𝙕"
	],
	"Á": [
		"𝗔́",
		"𝘈́",
		"𝘼́"
	],
	"É": [
		"𝗘́",
		"𝘌́",
		"𝙀́"
	],
	"Í": [
		"𝗜́",
		"𝘐́",
		"𝙄́"
	],
	"Ó": [
		"𝗢́",
		"𝘖́",
		"𝙊́"
	],
	"Ú": [
		"𝗨̈",
		"𝘜̈",
		"𝙐̈"
	]
}


export const negrita = (sel) => {

	// sel = sel.replace(/É/g, "{boldReplacementKey-ET}");
	// sel = sel.replace(/𝗘́/g, "É");
	// sel = sel.replace(/𝘌́/g, "{boldItalicReplacementKey-ET}");
	// sel = sel.replace(/𝙀́/g, "𝘌́");
	// sel = sel.replace(/{boldReplacementKey-ET}/g, "𝗘́");
	// sel = sel.replace(/{boldItalicReplacementKey-ET}/g, "𝙀́");


	sel = sel.replace(/a/g, "{boldReplacementKey-a}");
	sel = sel.replace(/𝗮/g, "a");
	// sel = sel.replace(/𝗮/g, "{Normal}");
	sel = sel.replace(/𝘢/g, "{boldItalicReplacementKey-a}");
	sel = sel.replace(/𝙖/g, "𝘢");
	sel = sel.replace(/{boldReplacementKey-a}/g, "𝗮");
	sel = sel.replace(/{boldItalicReplacementKey-a}/g, "𝙖");

	// Tildes
	// sel = sel.replace(/á/g, "{normalReplacementKey-at}");
	sel = sel.replace(/á/g, "{boldReplacementKey-at}");
	// sel = sel.replace(/𝗮́/g, "á");
	// sel = sel.replace(/𝘢́/g, "{boldItalicReplacementKey-at}");
	// sel = sel.replace(/𝙖́/g, "𝘢́");
	sel = sel.replace(/{boldReplacementKey-at}/g, "𝗮́");
	// sel = sel.replace(/{boldItalicReplacementKey-at}/g, "𝙖́");
	// sel = sel.replace(/{normalReplacementKey-at}/g, "á");

	sel = sel.replace(/b/g, "{boldReplacementKey-b}");
	sel = sel.replace(/𝗯/g, "b");
	sel = sel.replace(/𝘣/g, "{boldItalicReplacementKey-b}");
	sel = sel.replace(/𝙗/g, "𝘣");
	sel = sel.replace(/{boldReplacementKey-b}/g, "𝗯");
	sel = sel.replace(/{boldItalicReplacementKey-b}/g, "𝙗");
	sel = sel.replace(/c/g, "{boldReplacementKey-c}");
	sel = sel.replace(/𝗰/g, "c");

	sel = sel.replace(/𝘤/g, "{boldItalicReplacementKey-c}");
	sel = sel.replace(/𝙘/g, "𝘤");
	sel = sel.replace(/{boldReplacementKey-c}/g, "𝗰");
	sel = sel.replace(/{boldItalicReplacementKey-c}/g, "𝙘");
	sel = sel.replace(/d/g, "{boldReplacementKey-d}");
	sel = sel.replace(/𝗱/g, "d");

	sel = sel.replace(/𝘥/g, "{boldItalicReplacementKey-d}");
	sel = sel.replace(/𝙙/g, "𝘥");
	sel = sel.replace(/{boldReplacementKey-d}/g, "𝗱");
	sel = sel.replace(/{boldItalicReplacementKey-d}/g, "𝙙");

	sel = sel.replace(/e/g, "{boldReplacementKey-e}");
	sel = sel.replace(/𝗲/g, "e");
	sel = sel.replace(/𝘦/g, "{boldItalicReplacementKey-e}");
	sel = sel.replace(/𝙚/g, "𝘦");
	sel = sel.replace(/{boldReplacementKey-e}/g, "𝗲");
	sel = sel.replace(/{boldItalicReplacementKey-e}/g, "𝙚");

	// Tildes
	sel = sel.replace(/é/g, "{normalReplacementKey-et}");
	sel = sel.replace(/é/g, "{boldReplacementKey-et}");
	// sel = sel.replace(/𝗲́/g, "é");
	// sel = sel.replace(/𝘦́/g, "{boldItalicReplacementKey-et}");
	// sel = sel.replace(/𝙚́/g, "𝘦́");
	sel = sel.replace(/{boldReplacementKey-et}/g, "𝗲́");
	// sel = sel.replace(/{boldItalicReplacementKey-et}/g, "𝙚́");
	sel = sel.replace(/{normalReplacementKey-et}/g, "é");

	sel = sel.replace(/f/g, "{boldReplacementKey-f}");
	sel = sel.replace(/𝗳/g, "f");
	sel = sel.replace(/𝘧/g, "{boldItalicReplacementKey-f}");
	sel = sel.replace(/𝙛/g, "𝘧");
	sel = sel.replace(/{boldReplacementKey-f}/g, "𝗳");
	sel = sel.replace(/{boldItalicReplacementKey-f}/g, "𝙛");
	sel = sel.replace(/g/g, "{boldReplacementKey-g}");

	sel = sel.replace(/𝗴/g, "g");
	sel = sel.replace(/𝘨/g, "{boldItalicReplacementKey-g}");
	sel = sel.replace(/𝙜/g, "𝘨");
	sel = sel.replace(/{boldReplacementKey-g}/g, "𝗴");
	sel = sel.replace(/{boldItalicReplacementKey-g}/g, "𝙜");
	sel = sel.replace(/h/g, "{boldReplacementKey-h}");

	sel = sel.replace(/𝗵/g, "h");
	sel = sel.replace(/𝘩/g, "{boldItalicReplacementKey-h}");
	sel = sel.replace(/𝙝/g, "𝘩");
	sel = sel.replace(/{boldReplacementKey-h}/g, "𝗵");
	sel = sel.replace(/{boldItalicReplacementKey-h}/g, "𝙝");

	sel = sel.replace(/i/g, "{boldReplacementKey-i}");
	sel = sel.replace(/𝗶/g, "i");
	sel = sel.replace(/𝘪/g, "{boldItalicReplacementKey-i}");
	sel = sel.replace(/𝙞/g, "𝘪");
	sel = sel.replace(/{boldReplacementKey-i}/g, "𝗶");
	sel = sel.replace(/{boldItalicReplacementKey-i}/g, "𝙞");
	// Tildes ======== de la I =======
	// sel = sel.replace(/é/g, "{normalReplacementKey-at}");
	// sel = sel.replace(/é/g, "{boldReplacementKey-at}");
	// sel = sel.replace(/𝗲́/g, "é");
	// sel = sel.replace(/𝘦́/g, "{boldItalicReplacementKey-at}");
	// sel = sel.replace(/𝙚́/g, "𝘦́");
	// sel = sel.replace(/{boldReplacementKey-at}/g, "𝗲́");
	// sel = sel.replace(/{boldItalicReplacementKey-at}/g, "𝙚́");
	// sel = sel.replace(/{normalReplacementKey-at}/g, "é");


	sel = sel.replace(/j/g, "{boldReplacementKey-j}");
	sel = sel.replace(/𝗷/g, "j");
	sel = sel.replace(/𝘫/g, "{boldItalicReplacementKey-j}");
	sel = sel.replace(/𝙟/g, "𝘫");
	sel = sel.replace(/{boldReplacementKey-j}/g, "𝗷");
	sel = sel.replace(/{boldItalicReplacementKey-j}/g, "𝙟");

	sel = sel.replace(/k/g, "{boldReplacementKey-k}");
	sel = sel.replace(/𝗸/g, "k");
	sel = sel.replace(/𝘬/g, "{boldItalicReplacementKey-k}");
	sel = sel.replace(/𝙠/g, "𝘬");
	sel = sel.replace(/{boldReplacementKey-k}/g, "𝗸");
	sel = sel.replace(/{boldItalicReplacementKey-k}/g, "𝙠");

	sel = sel.replace(/l/g, "{boldReplacementKey-l}");
	sel = sel.replace(/𝗹/g, "l");
	sel = sel.replace(/𝘭/g, "{boldItalicReplacementKey-l}");
	sel = sel.replace(/𝙡/g, "𝘭");
	sel = sel.replace(/{boldReplacementKey-l}/g, "𝗹");
	sel = sel.replace(/{boldItalicReplacementKey-l}/g, "𝙡");

	sel = sel.replace(/m/g, "{boldReplacementKey-m}");
	sel = sel.replace(/𝗺/g, "m");
	sel = sel.replace(/𝘮/g, "{boldItalicReplacementKey-m}");
	sel = sel.replace(/𝙢/g, "𝘮");
	sel = sel.replace(/{boldReplacementKey-m}/g, "𝗺");
	sel = sel.replace(/{boldItalicReplacementKey-m}/g, "𝙢");

	sel = sel.replace(/n/g, "{boldReplacementKey-n}");
	sel = sel.replace(/𝗻/g, "n");
	sel = sel.replace(/𝘯/g, "{boldItalicReplacementKey-n}");
	sel = sel.replace(/𝙣/g, "𝘯");
	sel = sel.replace(/{boldReplacementKey-n}/g, "𝗻");
	sel = sel.replace(/{boldItalicReplacementKey-n}/g, "𝙣");

	sel = sel.replace(/o/g, "{boldReplacementKey-o}");
	sel = sel.replace(/𝗼/g, "o");
	sel = sel.replace(/𝘰/g, "{boldItalicReplacementKey-o}");
	sel = sel.replace(/𝙤/g, "𝘰");
	sel = sel.replace(/{boldReplacementKey-o}/g, "𝗼");
	sel = sel.replace(/{boldItalicReplacementKey-o}/g, "𝙤");
	// Tildes
	sel = sel.replace(/ó/g, "{normalReplacementKey-ot}");
	sel = sel.replace(/ó/g, "{boldReplacementKey-ot}");
	// sel = sel.replace(/𝗼́/g, "ó");
	// sel = sel.replace(/𝘰́/g, "{boldItalicReplacementKey-ot}");
	// sel = sel.replace(/𝙤́/g, "𝘰́");
	sel = sel.replace(/{boldReplacementKey-ot}/g, "𝗼́");
	// sel = sel.replace(/{boldItalicReplacementKey-ot}/g, "𝙤́");
	sel = sel.replace(/{normalReplacementKey-ot}/g, "ó");

	sel = sel.replace(/p/g, "{boldReplacementKey-p}");
	sel = sel.replace(/𝗽/g, "p");
	sel = sel.replace(/𝑝/g, "{boldItalicReplacementKey-p}");
	sel = sel.replace(/𝙥/g, "𝑝");
	sel = sel.replace(/{boldReplacementKey-p}/g, "𝗽");
	sel = sel.replace(/{boldItalicReplacementKey-p}/g, "𝙥");

	sel = sel.replace(/q/g, "{boldReplacementKey-q}");
	sel = sel.replace(/𝗾/g, "q");
	sel = sel.replace(/𝘲/g, "{boldItalicReplacementKey-q}");
	sel = sel.replace(/𝙦/g, "𝘲");
	sel = sel.replace(/{boldReplacementKey-q}/g, "𝗾");
	sel = sel.replace(/{boldItalicReplacementKey-q}/g, "𝙦");

	sel = sel.replace(/r/g, "{boldReplacementKey-r}");
	sel = sel.replace(/𝗿/g, "r");
	sel = sel.replace(/𝘳/g, "{boldItalicReplacementKey-r}");
	sel = sel.replace(/𝙧/g, "𝘳");
	sel = sel.replace(/{boldReplacementKey-r}/g, "𝗿");
	sel = sel.replace(/{boldItalicReplacementKey-r}/g, "𝙧");

	sel = sel.replace(/s/g, "{boldReplacementKey-s}");
	sel = sel.replace(/𝘀/g, "s");
	sel = sel.replace(/𝘴/g, "{boldItalicReplacementKey-s}");
	sel = sel.replace(/𝙨/g, "𝘴");
	sel = sel.replace(/{boldReplacementKey-s}/g, "𝘀");
	sel = sel.replace(/{boldItalicReplacementKey-s}/g, "𝙨");

	sel = sel.replace(/t/g, "{boldReplacementKey-t}");
	sel = sel.replace(/𝘁/g, "t");
	sel = sel.replace(/𝘵/g, "{boldItalicReplacementKey-t}");
	sel = sel.replace(/𝙩/g, "𝘵");
	sel = sel.replace(/{boldReplacementKey-t}/g, "𝘁");
	sel = sel.replace(/{boldItalicReplacementKey-t}/g, "𝙩");

	sel = sel.replace(/u/g, "{boldReplacementKey-u}");
	sel = sel.replace(/𝘂/g, "u");
	sel = sel.replace(/𝘶/g, "{boldItalicReplacementKey-u}");
	sel = sel.replace(/𝙪/g, "𝘶");
	sel = sel.replace(/{boldReplacementKey-u}/g, "𝘂");
	sel = sel.replace(/{boldItalicReplacementKey-u}/g, "𝙪");
	// Tildes
	sel = sel.replace(/ú/g, "{normalReplacementKey-ut}");
	sel = sel.replace(/ú/g, "{boldReplacementKey-ut}");
	// sel = sel.replace(/𝘂́/g, "ú");
	// sel = sel.replace(/𝘶́/g, "{boldItalicReplacementKey-ut}");
	// sel = sel.replace(/𝙪́/g, "𝘶́");
	sel = sel.replace(/{boldReplacementKey-ut}/g, "𝘂́");
	// sel = sel.replace(/{boldItalicReplacementKey-ut}/g, "𝙪́");
	sel = sel.replace(/{normalReplacementKey-ut}/g, "ú");
	// Diresis
	sel = sel.replace(/ü/g, "{normalReplacementKey-ud}");
	sel = sel.replace(/ü/g, "{boldReplacementKey-ud}");
	// sel = sel.replace(/𝘂̈/g, "ü");
	// sel = sel.replace(/𝘶̈/g, "{boldItalicReplacementKey-ud}");
	// sel = sel.replace(/𝙪̈/g, "𝘶̈");
	sel = sel.replace(/{boldReplacementKey-ud}/g, "𝘂̈");
	// sel = sel.replace(/{boldItalicReplacementKey-ud}/g, "𝙪̈");
	sel = sel.replace(/{normalReplacementKey-ud}/g, "ü");

	sel = sel.replace(/v/g, "{boldReplacementKey-v}");
	sel = sel.replace(/𝘃/g, "v");
	sel = sel.replace(/𝘷/g, "{boldItalicReplacementKey-v}");
	sel = sel.replace(/𝙫/g, "𝘷");
	sel = sel.replace(/{boldReplacementKey-v}/g, "𝘃");
	sel = sel.replace(/{boldItalicReplacementKey-v}/g, "𝙫");
	sel = sel.replace(/w/g, "{boldReplacementKey-w}");
	sel = sel.replace(/𝘄/g, "w");

	sel = sel.replace(/𝘸/g, "{boldItalicReplacementKey-w}");
	sel = sel.replace(/𝙬/g, "𝘸");
	sel = sel.replace(/{boldReplacementKey-w}/g, "𝘄");
	sel = sel.replace(/{boldItalicReplacementKey-w}/g, "𝙬");
	sel = sel.replace(/x/g, "{boldReplacementKey-x}");

	sel = sel.replace(/𝘅/g, "x");
	sel = sel.replace(/𝘹/g, "{boldItalicReplacementKey-x}");
	sel = sel.replace(/𝙭/g, "𝘹");
	sel = sel.replace(/{boldReplacementKey-x}/g, "𝘅");
	sel = sel.replace(/{boldItalicReplacementKey-x}/g, "𝙭");
	sel = sel.replace(/y/g, "{boldReplacementKey-y}");
	sel = sel.replace(/𝘆/g, "y");

	sel = sel.replace(/𝘺/g, "{boldItalicReplacementKey-y}");
	sel = sel.replace(/𝙮/g, "𝘺");
	sel = sel.replace(/{boldReplacementKey-y}/g, "𝘆");
	sel = sel.replace(/{boldItalicReplacementKey-y}/g, "𝙮");

	sel = sel.replace(/z/g, "{boldReplacementKey-z}");
	sel = sel.replace(/𝘇/g, "z");
	sel = sel.replace(/𝘻/g, "{boldItalicReplacementKey-z}");
	sel = sel.replace(/𝙯/g, "𝘻");
	sel = sel.replace(/{boldReplacementKey-z}/g, "𝘇");
	sel = sel.replace(/{boldItalicReplacementKey-z}/g, "𝙯");

	sel = sel.replace(/1/g, "{boldReplacementKey-1}");
	sel = sel.replace(/𝟭/g, "1");
	// sel = sel.replace(/𝟭/g, "{boldItalicReplacementKey-1}");
	// sel = sel.replace(/𝟭/g, "𝟭");
	sel = sel.replace(/{boldReplacementKey-1}/g, "𝟭");
	// sel = sel.replace(/{boldItalicReplacementKey-1}/g, "𝟭");

	sel = sel.replace(/2/g, "{boldReplacementKey-2}");
	sel = sel.replace(/𝟮/g, "2");
	// sel = sel.replace(/𝟮/g, "{boldItalicReplacementKey-2}");
	// sel = sel.replace(/2/g, "2");
	sel = sel.replace(/{boldReplacementKey-2}/g, "𝟮");
	// sel = sel.replace(/{boldItalicReplacementKey-2}/g, "2");

	sel = sel.replace(/3/g, "{boldReplacementKey-3}");
	sel = sel.replace(/𝟯/g, "3");
	// sel = sel.replace(/3/g, "{boldItalicReplacementKey-3}");
	// sel = sel.replace(/3/g, "3");
	sel = sel.replace(/{boldReplacementKey-3}/g, "𝟯");
	// sel = sel.replace(/{boldItalicReplacementKey-3}/g, "3");

	sel = sel.replace(/4/g, "{boldReplacementKey-4}");
	sel = sel.replace(/𝟰/g, "4");
	// sel = sel.replace(/4/g, "{boldItalicReplacementKey-4}");
	// sel = sel.replace(/4/g, "4");
	sel = sel.replace(/{boldReplacementKey-4}/g, "𝟰");
	// sel = sel.replace(/{boldItalicReplacementKey-4}/g, "4");

	sel = sel.replace(/5/g, "{boldReplacementKey-5}");
	sel = sel.replace(/𝟱/g, "5");
	// sel = sel.replace(/5/g, "{boldItalicReplacementKey-5}");
	// sel = sel.replace(/5/g, "5");
	sel = sel.replace(/{boldReplacementKey-5}/g, "𝟱");
	// sel = sel.replace(/{boldItalicReplacementKey-5}/g, "5");

	sel = sel.replace(/6/g, "{boldReplacementKey-6}");
	sel = sel.replace(/𝟲/g, "6");
	// sel = sel.replace(/6/g, "{boldItalicReplacementKey-6}");
	// sel = sel.replace(/6/g, "6");
	sel = sel.replace(/{boldReplacementKey-6}/g, "𝟲");
	// sel = sel.replace(/{boldItalicReplacementKey-6}/g, "6");

	sel = sel.replace(/7/g, "{boldReplacementKey-7}");
	sel = sel.replace(/𝟳/g, "7");
	// sel = sel.replace(/7/g, "{boldItalicReplacementKey-7}");
	// sel = sel.replace(/7/g, "7");
	sel = sel.replace(/{boldReplacementKey-7}/g, "𝟳");
	// sel = sel.replace(/{boldItalicReplacementKey-7}/g, "7");

	sel = sel.replace(/8/g, "{boldReplacementKey-8}");
	sel = sel.replace(/𝟴/g, "8");
	// sel = sel.replace(/8/g, "{boldItalicReplacementKey-8}");
	// sel = sel.replace(/8/g, "8");
	sel = sel.replace(/{boldReplacementKey-8}/g, "𝟴");
	// sel = sel.replace(/{boldItalicReplacementKey-8}/g, "8");

	sel = sel.replace(/9/g, "{boldReplacementKey-9}");
	sel = sel.replace(/𝟵/g, "9");
	// sel = sel.replace(/9/g, "{boldItalicReplacementKey-9}");
	// sel = sel.replace(/9/g, "9");
	sel = sel.replace(/{boldReplacementKey-9}/g, "𝟵");
	// sel = sel.replace(/{boldItalicReplacementKey-9}/g, "9");

	sel = sel.replace(/0/g, "{boldReplacementKey-0}");
	sel = sel.replace(/𝟬/g, "0");
	// sel = sel.replace(/0/g, "{boldItalicReplacementKey-0}");
	// sel = sel.replace(/0/g, "0");
	sel = sel.replace(/{boldReplacementKey-0}/g, "𝟬");
	// sel = sel.replace(/{boldItalicReplacementKey-0}/g, "0");

	sel = sel.replace(/A/g, "{boldReplacementKey-A}");
	sel = sel.replace(/𝗔/g, "A");
	sel = sel.replace(/𝘈/g, "{boldItalicReplacementKey-A}");
	sel = sel.replace(/𝘼/g, "𝘈");
	sel = sel.replace(/{boldReplacementKey-A}/g, "𝗔");
	sel = sel.replace(/{boldItalicReplacementKey-A}/g, "𝘼");

	sel = sel.replace(/B/g, "{boldReplacementKey-B}");

	sel = sel.replace(/𝗕/g, "B");
	sel = sel.replace(/𝘉/g, "{boldItalicReplacementKey-B}");
	sel = sel.replace(/𝘽/g, "𝘉");
	sel = sel.replace(/{boldReplacementKey-B}/g, "𝗕");
	sel = sel.replace(/{boldItalicReplacementKey-B}/g, "𝘽");
	sel = sel.replace(/C/g, "{boldReplacementKey-C}");
	sel = sel.replace(/𝗖/g, "C");

	sel = sel.replace(/𝘊/g, "{boldItalicReplacementKey-C}");
	sel = sel.replace(/𝘾/g, "𝘊");
	sel = sel.replace(/{boldReplacementKey-C}/g, "𝗖");
	sel = sel.replace(/{boldItalicReplacementKey-C}/g, "𝘾");
	sel = sel.replace(/D/g, "{boldReplacementKey-D}");

	sel = sel.replace(/𝗗/g, "D");
	sel = sel.replace(/𝘋/g, "{boldItalicReplacementKey-D}");
	sel = sel.replace(/𝘿/g, "𝘋");
	sel = sel.replace(/{boldReplacementKey-D}/g, "𝗗");
	sel = sel.replace(/{boldItalicReplacementKey-D}/g, "𝘿");
	sel = sel.replace(/E/g, "{boldReplacementKey-E}");
	sel = sel.replace(/𝗘/g, "E");

	sel = sel.replace(/𝘌/g, "{boldItalicReplacementKey-E}");
	sel = sel.replace(/𝙀/g, "𝘌");
	sel = sel.replace(/{boldReplacementKey-E}/g, "𝗘");
	sel = sel.replace(/{boldItalicReplacementKey-E}/g, "𝙀");

	sel = sel.replace(/F/g, "{boldReplacementKey-F}");
	sel = sel.replace(/𝗙/g, "F");
	sel = sel.replace(/𝘍/g, "{boldItalicReplacementKey-F}");
	sel = sel.replace(/𝙁/g, "𝘍");
	sel = sel.replace(/{boldReplacementKey-F}/g, "𝗙");
	sel = sel.replace(/{boldItalicReplacementKey-F}/g, "𝙁");

	sel = sel.replace(/G/g, "{boldReplacementKey-G}");
	sel = sel.replace(/𝗚/g, "G");
	sel = sel.replace(/𝘎/g, "{boldItalicReplacementKey-G}");
	sel = sel.replace(/𝙂/g, "𝘎");
	sel = sel.replace(/{boldReplacementKey-G}/g, "𝗚");
	sel = sel.replace(/{boldItalicReplacementKey-G}/g, "𝙂");
	sel = sel.replace(/H/g, "{boldReplacementKey-H}");
	sel = sel.replace(/𝗛/g, "H");
	sel = sel.replace(/𝘏/g, "{boldItalicReplacementKey-H}");
	sel = sel.replace(/𝙃/g, "𝘏");
	sel = sel.replace(/{boldReplacementKey-H}/g, "𝗛");
	sel = sel.replace(/{boldItalicReplacementKey-H}/g, "𝙃");

	sel = sel.replace(/I/g, "{boldReplacementKey-I}");
	sel = sel.replace(/𝗜/g, "I");
	sel = sel.replace(/𝘐/g, "{boldItalicReplacementKey-I}");
	sel = sel.replace(/𝙄/g, "𝘐");
	sel = sel.replace(/{boldReplacementKey-I}/g, "𝗜");
	sel = sel.replace(/{boldItalicReplacementKey-I}/g, "𝙄");

	sel = sel.replace(/J/g, "{boldReplacementKey-J}");
	sel = sel.replace(/𝗝/g, "J");
	sel = sel.replace(/𝘑/g, "{boldItalicReplacementKey-J}");
	sel = sel.replace(/𝙅/g, "𝘑");
	sel = sel.replace(/{boldReplacementKey-J}/g, "𝗝");
	sel = sel.replace(/{boldItalicReplacementKey-J}/g, "𝙅");

	sel = sel.replace(/K/g, "{boldReplacementKey-K}");
	sel = sel.replace(/𝗞/g, "K");
	sel = sel.replace(/𝘒/g, "{boldItalicReplacementKey-K}");
	sel = sel.replace(/𝙆/g, "𝘒");
	sel = sel.replace(/{boldReplacementKey-K}/g, "𝗞");
	sel = sel.replace(/{boldItalicReplacementKey-K}/g, "𝙆");

	sel = sel.replace(/L/g, "{boldReplacementKey-L}");
	sel = sel.replace(/𝗟/g, "L");
	sel = sel.replace(/𝘓/g, "{boldItalicReplacementKey-L}");
	sel = sel.replace(/𝙇/g, "𝘓");
	sel = sel.replace(/{boldReplacementKey-L}/g, "𝗟");
	sel = sel.replace(/{boldItalicReplacementKey-L}/g, "𝙇");

	sel = sel.replace(/M/g, "{boldReplacementKey-M}");
	sel = sel.replace(/𝗠/g, "M");
	sel = sel.replace(/𝘔/g, "{boldItalicReplacementKey-M}");
	sel = sel.replace(/𝙈/g, "𝘔");
	sel = sel.replace(/{boldReplacementKey-M}/g, "𝗠");
	sel = sel.replace(/{boldItalicReplacementKey-M}/g, "𝙈");

	sel = sel.replace(/N/g, "{boldReplacementKey-N}");
	sel = sel.replace(/𝗡/g, "N");
	sel = sel.replace(/𝘕/g, "{boldItalicReplacementKey-N}");
	sel = sel.replace(/𝙉/g, "𝘕");
	sel = sel.replace(/{boldReplacementKey-N}/g, "𝗡");
	sel = sel.replace(/{boldItalicReplacementKey-N}/g, "𝙉");

	sel = sel.replace(/O/g, "{boldReplacementKey-O}");
	sel = sel.replace(/𝗢/g, "O");
	sel = sel.replace(/𝘖/g, "{boldItalicReplacementKey-O}");
	sel = sel.replace(/𝙊/g, "𝘖");
	sel = sel.replace(/{boldReplacementKey-O}/g, "𝗢");
	sel = sel.replace(/{boldItalicReplacementKey-O}/g, "𝙊");

	sel = sel.replace(/P/g, "{boldReplacementKey-P}");
	sel = sel.replace(/𝗣/g, "P");
	sel = sel.replace(/𝘗/g, "{boldItalicReplacementKey-P}");
	sel = sel.replace(/𝙋/g, "𝘗");
	sel = sel.replace(/{boldReplacementKey-P}/g, "𝗣");
	sel = sel.replace(/{boldItalicReplacementKey-P}/g, "𝙋");

	sel = sel.replace(/Q/g, "{boldReplacementKey-Q}");
	sel = sel.replace(/𝗤/g, "Q");
	sel = sel.replace(/𝘘/g, "{boldItalicReplacementKey-Q}");
	sel = sel.replace(/𝙌/g, "𝘘");
	sel = sel.replace(/{boldReplacementKey-Q}/g, "𝗤");
	sel = sel.replace(/{boldItalicReplacementKey-Q}/g, "𝙌");

	sel = sel.replace(/R/g, "{boldReplacementKey-R}");
	sel = sel.replace(/𝗥/g, "R");
	sel = sel.replace(/𝘙/g, "{boldItalicReplacementKey-R}");
	sel = sel.replace(/𝙍/g, "𝘙");
	sel = sel.replace(/{boldReplacementKey-R}/g, "𝗥");
	sel = sel.replace(/{boldItalicReplacementKey-R}/g, "𝙍");

	sel = sel.replace(/S/g, "{boldReplacementKey-S}");
	sel = sel.replace(/𝗦/g, "S");
	sel = sel.replace(/𝘚/g, "{boldItalicReplacementKey-S}");
	sel = sel.replace(/𝙎/g, "𝘚");
	sel = sel.replace(/{boldReplacementKey-S}/g, "𝗦");
	sel = sel.replace(/{boldItalicReplacementKey-S}/g, "𝙎");

	sel = sel.replace(/T/g, "{boldReplacementKey-T}");
	sel = sel.replace(/𝗧/g, "T");
	sel = sel.replace(/𝘛/g, "{boldItalicReplacementKey-T}");
	sel = sel.replace(/𝙏/g, "𝘛");
	sel = sel.replace(/{boldReplacementKey-T}/g, "𝗧");
	sel = sel.replace(/{boldItalicReplacementKey-T}/g, "𝙏");

	sel = sel.replace(/U/g, "{boldReplacementKey-U}");
	sel = sel.replace(/𝗨/g, "U");
	sel = sel.replace(/𝘜/g, "{boldItalicReplacementKey-U}");
	sel = sel.replace(/𝙐/g, "𝘜");
	sel = sel.replace(/{boldReplacementKey-U}/g, "𝗨");
	sel = sel.replace(/{boldItalicReplacementKey-U}/g, "𝙐");

	sel = sel.replace(/V/g, "{boldReplacementKey-V}");
	sel = sel.replace(/𝗩/g, "V");
	sel = sel.replace(/𝘝/g, "{boldItalicReplacementKey-V}");
	sel = sel.replace(/𝙑/g, "𝘝");
	sel = sel.replace(/{boldReplacementKey-V}/g, "𝗩");
	sel = sel.replace(/{boldItalicReplacementKey-V}/g, "𝙑");

	sel = sel.replace(/X/g, "{boldReplacementKey-X}");
	sel = sel.replace(/𝗫/g, "X");
	sel = sel.replace(/𝘟/g, "{boldItalicReplacementKey-X}");
	sel = sel.replace(/𝙓/g, "𝘟");
	sel = sel.replace(/{boldReplacementKey-X}/g, "𝗫");
	sel = sel.replace(/{boldItalicReplacementKey-X}/g, "𝙓");

	sel = sel.replace(/Y/g, "{boldReplacementKey-Y}");
	sel = sel.replace(/𝗬/g, "Y");
	sel = sel.replace(/𝘠/g, "{boldItalicReplacementKey-Y}");
	sel = sel.replace(/𝙔/g, "𝘠");
	sel = sel.replace(/{boldReplacementKey-Y}/g, "𝗬");
	sel = sel.replace(/{boldItalicReplacementKey-Y}/g, "𝙔");

	sel = sel.replace(/Z/g, "{boldReplacementKey-Z}");
	sel = sel.replace(/𝗭/g, "Z");
	sel = sel.replace(/𝘡/g, "{boldItalicReplacementKey-Z}");
	sel = sel.replace(/𝙕/g, "𝘡");
	sel = sel.replace(/{boldReplacementKey-Z}/g, "𝗭");
	sel = sel.replace(/{boldItalicReplacementKey-Z}/g, "𝙕");

	// ? TILDE
	// * -- A --
	// sel = sel.replace(/Á/g, "{normalReplacementKey-et}");
	sel = sel.replace(/Á/g, "{boldReplacementKey-AT}");
	// sel = sel.replace(/𝗲́/g, "é");
	// sel = sel.replace(/𝘦́/g, "{boldItalicReplacementKey-et}");
	// sel = sel.replace(/𝙚́/g, "𝘦́");
	sel = sel.replace(/{boldReplacementKey-AT}/g, "𝗔́");
	// sel = sel.replace(/{boldItalicReplacementKey-et}/g, "𝙚́");
	sel = sel.replace(/{normalReplacementKey-AT}/g, "Á");

	// * -- E --
	// sel = sel.replace(/Á/g, "{normalReplacementKey-et}");
	sel = sel.replace(/É/g, "{boldReplacementKey-ET}");
	// sel = sel.replace(/𝗲́/g, "é");
	// sel = sel.replace(/𝘦́/g, "{boldItalicReplacementKey-et}");
	// sel = sel.replace(/𝙚́/g, "𝘦́");
	sel = sel.replace(/{boldReplacementKey-ET}/g, "𝗘́");
	// sel = sel.replace(/{boldItalicReplacementKey-et}/g, "𝙚́");
	sel = sel.replace(/{normalReplacementKey-ET}/g, "É");

	// * -- I --
	// sel = sel.replace(/Á/g, "{normalReplacementKey-et}");
	sel = sel.replace(/Í/g, "{boldReplacementKey-IT}");
	// sel = sel.replace(/𝗲́/g, "é");
	// sel = sel.replace(/𝘦́/g, "{boldItalicReplacementKey-et}");
	// sel = sel.replace(/𝙚́/g, "𝘦́");
	sel = sel.replace(/{boldReplacementKey-IT}/g, "𝗜́");
	// sel = sel.replace(/{boldItalicReplacementKey-et}/g, "𝙚́");
	sel = sel.replace(/{normalReplacementKey-IT}/g, "Í");

	// * -- O --
	// sel = sel.replace(/Á/g, "{normalReplacementKey-et}");
	sel = sel.replace(/Ó/g, "{boldReplacementKey-OT}");
	// sel = sel.replace(/𝗲́/g, "é");
	// sel = sel.replace(/𝘦́/g, "{boldItalicReplacementKey-et}");
	// sel = sel.replace(/𝙚́/g, "𝘦́");
	sel = sel.replace(/{boldReplacementKey-OT}/g, "𝗢́");
	// sel = sel.replace(/{boldItalicReplacementKey-et}/g, "𝙚́");
	sel = sel.replace(/{normalReplacementKey-OT}/g, "Ó");
	// * -- U --
	// sel = sel.replace(/Á/g, "{normalReplacementKey-et}");
	sel = sel.replace(/Ú/g, "{boldReplacementKey-UT}");
	// sel = sel.replace(/𝗲́/g, "é");
	// sel = sel.replace(/𝘦́/g, "{boldItalicReplacementKey-et}");
	// sel = sel.replace(/𝙚́/g, "𝘦́");
	sel = sel.replace(/{boldReplacementKey-UT}/g, "𝗨́");
	// sel = sel.replace(/{boldItalicReplacementKey-et}/g, "𝙚́");
	sel = sel.replace(/{normalReplacementKey-UT}/g, "Ú");




	// "Á": [
	// 	"𝗔́",
	// 	"𝘈́",
	// 	"𝘼́"
	// ],
	// "É": [
	// 	"𝗘́",
	// 	"𝘌́",
	// 	"𝙀́"
	// ],
	// "Í": [
	// 	"𝗜́",
	// 	"𝘐́",
	// 	"𝙄́"
	// ],
	// "Ó": [
	// 	"𝗢́",
	// 	"𝘖́",
	// 	"𝙊́"
	// ],
	// "Ú": [
	// 	"𝗨́",
	// 	"𝘜́",
	// 	"𝙐́"
	// ]





	// arrLetters.map((letter) => {
	// 	const val = arrLettersBold[letter];
	// 	console.log(`sel = sel.replace(/${letter}/g, "{boldReplacementKey-${letter}}");`)
	// 	console.log(`sel = sel.replace(/${val[0]}/g, "${letter}");`);
	// 	// Si es cursiva (cambiar a cursiva negrita)
	// 	console.log(`sel = sel.replace(/${val[1]}/g, "{boldItalicReplacementKey-${letter}}");`)
	// 	// Si es cursiva negrita cambiar a cursiva.
	// 	console.log(`sel = sel.replace(/${val[2]}/g, "${val[1]}");`)
	// 	console.log(`sel = sel.replace(/{boldReplacementKey-${letter}}/g, "${val[0]}");`)
	// 	console.log(`sel = sel.replace(/{boldItalicReplacementKey-${letter}}/g, "${val[2]}");`)
	// })


	return sel;
}


export const cursiva = (sel) => {

	// arrLetters.map((letter) => {
	// 	const val = arrLettersBold[letter];
	// 	console.log(`sel = sel.replace(/${letter}/g, "{italicReplacementKey-${letter}}");`)
	// 	console.log(`sel = sel.replace(/${val[1]}/g, "${letter}");`);
	// 	// Si es negrita (cambiar a cursiva negrita)
	// 	console.log(`sel = sel.replace(/${val[0]}/g, "{italicBoldReplacementKey-${letter}}");`)
	// 	// Si es cursiva negrita cambiar a negrita.
	// 	console.log(`sel = sel.replace(/${val[2]}/g, "${val[0]}");`)
	// 	console.log(`sel = sel.replace(/{italicReplacementKey-${letter}}/g, "${val[1]}");`)
	// 	console.log(`sel = sel.replace(/{italicBoldReplacementKey-${letter}}/g, "${val[2]}");`)
	// })

	sel = sel.replace(/a/g, "{italicReplacementKey-a}");
	sel = sel.replace(/𝘢/g, "a");
	sel = sel.replace(/𝗮/g, "{italicBoldReplacementKey-a}");
	sel = sel.replace(/𝙖/g, "𝗮");
	sel = sel.replace(/{italicReplacementKey-a}/g, "𝘢");
	sel = sel.replace(/{italicBoldReplacementKey-a}/g, "𝙖");
	// Tildes
	sel = sel.replace(/á/g, "{normalReplacementKey-at}");
	sel = sel.replace(/á/g, "{italicReplacementKey-at}");
	// sel = sel.replace(/𝘢́/g, "á");
	// sel = sel.replace(/𝗮́/g, "{boldItalicReplacementKey-at}");
	// sel = sel.replace(/𝙖́/g, "𝘢́");
	sel = sel.replace(/{italicReplacementKey-at}/g, "𝘢́");
	// sel = sel.replace(/{boldItalicReplacementKey-at}/g, "𝙖́");
	sel = sel.replace(/{normalReplacementKey-at}/g, "á");

	sel = sel.replace(/b/g, "{italicReplacementKey-b}");
	sel = sel.replace(/𝘣/g, "b");
	sel = sel.replace(/𝗯/g, "{italicBoldReplacementKey-b}");
	sel = sel.replace(/𝙗/g, "𝗯");
	sel = sel.replace(/{italicReplacementKey-b}/g, "𝘣");
	sel = sel.replace(/{italicBoldReplacementKey-b}/g, "𝙗");

	sel = sel.replace(/c/g, "{italicReplacementKey-c}");
	sel = sel.replace(/𝘤/g, "c");
	sel = sel.replace(/𝗰/g, "{italicBoldReplacementKey-c}");
	sel = sel.replace(/𝙘/g, "𝗰");
	sel = sel.replace(/{italicReplacementKey-c}/g, "𝘤");
	sel = sel.replace(/{italicBoldReplacementKey-c}/g, "𝙘");

	sel = sel.replace(/d/g, "{italicReplacementKey-d}");
	sel = sel.replace(/𝘥/g, "d");
	sel = sel.replace(/𝗱/g, "{italicBoldReplacementKey-d}");
	sel = sel.replace(/𝙙/g, "𝗱");
	sel = sel.replace(/{italicReplacementKey-d}/g, "𝘥");
	sel = sel.replace(/{italicBoldReplacementKey-d}/g, "𝙙");

	sel = sel.replace(/e/g, "{italicReplacementKey-e}");
	sel = sel.replace(/𝘦/g, "e");
	sel = sel.replace(/𝗲/g, "{italicBoldReplacementKey-e}");
	sel = sel.replace(/𝙚/g, "𝗲");
	sel = sel.replace(/{italicReplacementKey-e}/g, "𝘦");
	sel = sel.replace(/{italicBoldReplacementKey-e}/g, "𝙚");
	// Tildes
	sel = sel.replace(/é/g, "{normalReplacementKey-et}");
	sel = sel.replace(/é/g, "{italicReplacementKey-et}");
	// sel = sel.replace(/𝗲́/g, "é");
	// sel = sel.replace(/𝘦́/g, "{boldItalicReplacementKey-et}");
	// sel = sel.replace(/𝙚́/g, "𝘦́");
	sel = sel.replace(/{italicReplacementKey-et}/g, "𝘦́");
	// sel = sel.replace(/{boldItalicReplacementKey-et}/g, "𝙚́");
	sel = sel.replace(/{normalReplacementKey-et}/g, "é");


	sel = sel.replace(/f/g, "{italicReplacementKey-f}");
	sel = sel.replace(/𝘧/g, "f");
	sel = sel.replace(/𝗳/g, "{italicBoldReplacementKey-f}");
	sel = sel.replace(/𝙛/g, "𝗳");
	sel = sel.replace(/{italicReplacementKey-f}/g, "𝘧");
	sel = sel.replace(/{italicBoldReplacementKey-f}/g, "𝙛");
	sel = sel.replace(/g/g, "{italicReplacementKey-g}");
	sel = sel.replace(/𝘨/g, "g");
	sel = sel.replace(/𝗴/g, "{italicBoldReplacementKey-g}");
	sel = sel.replace(/𝙜/g, "𝗴");
	sel = sel.replace(/{italicReplacementKey-g}/g, "𝘨");
	sel = sel.replace(/{italicBoldReplacementKey-g}/g, "𝙜");
	sel = sel.replace(/h/g, "{italicReplacementKey-h}");
	sel = sel.replace(/𝘩/g, "h");
	sel = sel.replace(/𝗵/g, "{italicBoldReplacementKey-h}");
	sel = sel.replace(/𝙝/g, "𝗵");
	sel = sel.replace(/{italicReplacementKey-h}/g, "𝘩");
	sel = sel.replace(/{italicBoldReplacementKey-h}/g, "𝙝");

	sel = sel.replace(/i/g, "{italicReplacementKey-i}");
	sel = sel.replace(/𝘪/g, "i");
	sel = sel.replace(/𝗶/g, "{italicBoldReplacementKey-i}");
	sel = sel.replace(/𝙞/g, "𝗶");
	sel = sel.replace(/{italicReplacementKey-i}/g, "𝘪");
	sel = sel.replace(/{italicBoldReplacementKey-i}/g, "𝙞");

	sel = sel.replace(/j/g, "{italicReplacementKey-j}");
	sel = sel.replace(/𝘫/g, "j");
	sel = sel.replace(/𝗷/g, "{italicBoldReplacementKey-j}");
	sel = sel.replace(/𝙟/g, "𝗷");
	sel = sel.replace(/{italicReplacementKey-j}/g, "𝘫");
	sel = sel.replace(/{italicBoldReplacementKey-j}/g, "𝙟");

	sel = sel.replace(/k/g, "{italicReplacementKey-k}");
	sel = sel.replace(/𝘬/g, "k");
	sel = sel.replace(/𝗸/g, "{italicBoldReplacementKey-k}");
	sel = sel.replace(/𝙠/g, "𝗸");
	sel = sel.replace(/{italicReplacementKey-k}/g, "𝘬");
	sel = sel.replace(/{italicBoldReplacementKey-k}/g, "𝙠");

	sel = sel.replace(/l/g, "{italicReplacementKey-l}");
	sel = sel.replace(/𝘭/g, "l");
	sel = sel.replace(/𝗹/g, "{italicBoldReplacementKey-l}");
	sel = sel.replace(/𝙡/g, "𝗹");
	sel = sel.replace(/{italicReplacementKey-l}/g, "𝘭");
	sel = sel.replace(/{italicBoldReplacementKey-l}/g, "𝙡");

	sel = sel.replace(/m/g, "{italicReplacementKey-m}");
	sel = sel.replace(/𝘮/g, "m");
	sel = sel.replace(/𝗺/g, "{italicBoldReplacementKey-m}");
	sel = sel.replace(/𝙢/g, "𝗺");
	sel = sel.replace(/{italicReplacementKey-m}/g, "𝘮");
	sel = sel.replace(/{italicBoldReplacementKey-m}/g, "𝙢");

	sel = sel.replace(/n/g, "{italicReplacementKey-n}");
	sel = sel.replace(/𝘯/g, "n");
	sel = sel.replace(/𝗻/g, "{italicBoldReplacementKey-n}");
	sel = sel.replace(/𝙣/g, "𝗻");
	sel = sel.replace(/{italicReplacementKey-n}/g, "𝘯");
	sel = sel.replace(/{italicBoldReplacementKey-n}/g, "𝙣");

	sel = sel.replace(/o/g, "{italicReplacementKey-o}");
	sel = sel.replace(/𝘰/g, "o");
	sel = sel.replace(/𝗼/g, "{italicBoldReplacementKey-o}");
	sel = sel.replace(/𝙤/g, "𝗼");
	sel = sel.replace(/{italicReplacementKey-o}/g, "𝘰");
	sel = sel.replace(/{italicBoldReplacementKey-o}/g, "𝙤");
	// Tildes
	sel = sel.replace(/ó/g, "{normalReplacementKey-ot}");
	sel = sel.replace(/ó/g, "{italicReplacementKey-ot}");
	// sel = sel.replace(/𝗼́/g, "ó");
	// sel = sel.replace(/𝘰́/g, "{boldItalicReplacementKey-ot}");
	// sel = sel.replace(/𝙤́/g, "𝘰́");
	sel = sel.replace(/{italicReplacementKey-ot}/g, "𝘰́");
	// sel = sel.replace(/{boldItalicReplacementKey-ot}/g, "𝙤́");
	sel = sel.replace(/{normalReplacementKey-ot}/g, "ó");

	sel = sel.replace(/p/g, "{italicReplacementKey-p}");
	sel = sel.replace(/𝑝/g, "p");
	sel = sel.replace(/𝗽/g, "{italicBoldReplacementKey-p}");
	sel = sel.replace(/𝙥/g, "𝗽");
	sel = sel.replace(/{italicReplacementKey-p}/g, "𝑝");
	sel = sel.replace(/{italicBoldReplacementKey-p}/g, "𝙥");

	sel = sel.replace(/q/g, "{italicReplacementKey-q}");
	sel = sel.replace(/𝘲/g, "q");
	sel = sel.replace(/𝗾/g, "{italicBoldReplacementKey-q}");
	sel = sel.replace(/𝙦/g, "𝗾");
	sel = sel.replace(/{italicReplacementKey-q}/g, "𝘲");
	sel = sel.replace(/{italicBoldReplacementKey-q}/g, "𝙦");

	sel = sel.replace(/r/g, "{italicReplacementKey-r}");
	sel = sel.replace(/𝘳/g, "r");
	sel = sel.replace(/𝗿/g, "{italicBoldReplacementKey-r}");
	sel = sel.replace(/𝙧/g, "𝗿");
	sel = sel.replace(/{italicReplacementKey-r}/g, "𝘳");
	sel = sel.replace(/{italicBoldReplacementKey-r}/g, "𝙧");
	sel = sel.replace(/s/g, "{italicReplacementKey-s}");
	sel = sel.replace(/𝘴/g, "s");
	sel = sel.replace(/𝘀/g, "{italicBoldReplacementKey-s}");
	sel = sel.replace(/𝙨/g, "𝘀");
	sel = sel.replace(/{italicReplacementKey-s}/g, "𝘴");
	sel = sel.replace(/{italicBoldReplacementKey-s}/g, "𝙨");
	sel = sel.replace(/t/g, "{italicReplacementKey-t}");
	sel = sel.replace(/𝘵/g, "t");
	sel = sel.replace(/𝘁/g, "{italicBoldReplacementKey-t}");
	sel = sel.replace(/𝙩/g, "𝘁");
	sel = sel.replace(/{italicReplacementKey-t}/g, "𝘵");
	sel = sel.replace(/{italicBoldReplacementKey-t}/g, "𝙩");

	sel = sel.replace(/u/g, "{italicReplacementKey-u}");
	sel = sel.replace(/𝘶/g, "u");
	sel = sel.replace(/𝘂/g, "{italicBoldReplacementKey-u}");
	sel = sel.replace(/𝙪/g, "𝘂");
	sel = sel.replace(/{italicReplacementKey-u}/g, "𝘶");
	sel = sel.replace(/{italicBoldReplacementKey-u}/g, "𝙪");
	// TILDES
	sel = sel.replace(/ú/g, "{normalReplacementKey-ut}");
	sel = sel.replace(/ú/g, "{italicReplacementKey-ut}");
	// sel = sel.replace(/𝘂́/g, "ú");
	// sel = sel.replace(/𝘶́/g, "{boldItalicReplacementKey-ut}");
	// sel = sel.replace(/𝙪́/g, "𝘶́");
	sel = sel.replace(/{italicReplacementKey-ut}/g, "𝘶́");
	// sel = sel.replace(/{boldItalicReplacementKey-ut}/g, "𝙪́");
	sel = sel.replace(/{normalReplacementKey-ut}/g, "ú");
	// Diresis
	sel = sel.replace(/ü/g, "{normalReplacementKey-ud}");
	sel = sel.replace(/ü/g, "{italicReplacementKey-ud}");
	// sel = sel.replace(/𝘂̈/g, "ü");
	// sel = sel.replace(/𝘶̈/g, "{italicItalicReplacementKey-ud}");
	// sel = sel.replace(/𝙪̈/g, "𝘶̈");
	sel = sel.replace(/{italicReplacementKey-ud}/g, "𝘶̈");
	// sel = sel.replace(/{boldItalicReplacementKey-ud}/g, "𝙪̈");
	sel = sel.replace(/{normalReplacementKey-ud}/g, "ü");


	sel = sel.replace(/v/g, "{italicReplacementKey-v}");
	sel = sel.replace(/𝘷/g, "v");
	sel = sel.replace(/𝘃/g, "{italicBoldReplacementKey-v}");
	sel = sel.replace(/𝙫/g, "𝘃");
	sel = sel.replace(/{italicReplacementKey-v}/g, "𝘷");
	sel = sel.replace(/{italicBoldReplacementKey-v}/g, "𝙫");
	sel = sel.replace(/w/g, "{italicReplacementKey-w}");
	sel = sel.replace(/𝘸/g, "w");
	sel = sel.replace(/𝘄/g, "{italicBoldReplacementKey-w}");
	sel = sel.replace(/𝙬/g, "𝘄");
	sel = sel.replace(/{italicReplacementKey-w}/g, "𝘸");
	sel = sel.replace(/{italicBoldReplacementKey-w}/g, "𝙬");
	sel = sel.replace(/x/g, "{italicReplacementKey-x}");
	sel = sel.replace(/𝘹/g, "x");
	sel = sel.replace(/𝘅/g, "{italicBoldReplacementKey-x}");
	sel = sel.replace(/𝙭/g, "𝘅");
	sel = sel.replace(/{italicReplacementKey-x}/g, "𝘹");
	sel = sel.replace(/{italicBoldReplacementKey-x}/g, "𝙭");
	sel = sel.replace(/y/g, "{italicReplacementKey-y}");
	sel = sel.replace(/𝘺/g, "y");
	sel = sel.replace(/𝘆/g, "{italicBoldReplacementKey-y}");
	sel = sel.replace(/𝙮/g, "𝘆");
	sel = sel.replace(/{italicReplacementKey-y}/g, "𝘺");
	sel = sel.replace(/{italicBoldReplacementKey-y}/g, "𝙮");
	sel = sel.replace(/z/g, "{italicReplacementKey-z}");
	sel = sel.replace(/𝘻/g, "z");
	sel = sel.replace(/𝘇/g, "{italicBoldReplacementKey-z}");
	sel = sel.replace(/𝙯/g, "𝘇");
	sel = sel.replace(/{italicReplacementKey-z}/g, "𝘻");
	sel = sel.replace(/{italicBoldReplacementKey-z}/g, "𝙯");

	// sel = sel.replace(/1/g, "{italicReplacementKey-1}");
	// sel = sel.replace(/1/g, "1");
	// sel = sel.replace(/𝟭/g, "{italicBoldReplacementKey-1}");
	// sel = sel.replace(/1/g, "𝟭");
	// sel = sel.replace(/{italicReplacementKey-1}/g, "1");
	// sel = sel.replace(/{italicBoldReplacementKey-1}/g, "1");

	// sel = sel.replace(/2/g, "{italicReplacementKey-2}");
	// sel = sel.replace(/2/g, "2");
	// sel = sel.replace(/𝟮/g, "{italicBoldReplacementKey-2}");
	// sel = sel.replace(/2/g, "𝟮");
	// sel = sel.replace(/{italicReplacementKey-2}/g, "2");
	// sel = sel.replace(/{italicBoldReplacementKey-2}/g, "2");

	// sel = sel.replace(/3/g, "{italicReplacementKey-3}");
	// sel = sel.replace(/3/g, "3");
	// sel = sel.replace(/𝟯/g, "{italicBoldReplacementKey-3}");
	// sel = sel.replace(/3/g, "𝟯");
	// sel = sel.replace(/{italicReplacementKey-3}/g, "3");
	// sel = sel.replace(/{italicBoldReplacementKey-3}/g, "3");

	// sel = sel.replace(/4/g, "{italicReplacementKey-4}");
	// sel = sel.replace(/4/g, "4");
	// sel = sel.replace(/𝟰/g, "{italicBoldReplacementKey-4}");
	// sel = sel.replace(/4/g, "𝟰");
	// sel = sel.replace(/{italicReplacementKey-4}/g, "4");
	// sel = sel.replace(/{italicBoldReplacementKey-4}/g, "4");

	// sel = sel.replace(/5/g, "{italicReplacementKey-5}");
	// sel = sel.replace(/5/g, "5");
	// sel = sel.replace(/𝟱/g, "{italicBoldReplacementKey-5}");
	// sel = sel.replace(/5/g, "𝟱");
	// sel = sel.replace(/{italicReplacementKey-5}/g, "5");
	// sel = sel.replace(/{italicBoldReplacementKey-5}/g, "5");
	// sel = sel.replace(/6/g, "{italicReplacementKey-6}");
	// sel = sel.replace(/6/g, "6");
	// sel = sel.replace(/𝟲/g, "{italicBoldReplacementKey-6}");
	// sel = sel.replace(/6/g, "𝟲");
	// sel = sel.replace(/{italicReplacementKey-6}/g, "6");
	// sel = sel.replace(/{italicBoldReplacementKey-6}/g, "6");
	// sel = sel.replace(/7/g, "{italicReplacementKey-7}");
	// sel = sel.replace(/7/g, "7");
	// sel = sel.replace(/𝟳/g, "{italicBoldReplacementKey-7}");
	// sel = sel.replace(/7/g, "𝟳");
	// sel = sel.replace(/{italicReplacementKey-7}/g, "7");
	// sel = sel.replace(/{italicBoldReplacementKey-7}/g, "7");
	// sel = sel.replace(/8/g, "{italicReplacementKey-8}");
	// sel = sel.replace(/8/g, "8");
	// sel = sel.replace(/𝟴/g, "{italicBoldReplacementKey-8}");
	// sel = sel.replace(/8/g, "𝟴");
	// sel = sel.replace(/{italicReplacementKey-8}/g, "8");
	// sel = sel.replace(/{italicBoldReplacementKey-8}/g, "8");
	// sel = sel.replace(/9/g, "{italicReplacementKey-9}");
	// sel = sel.replace(/9/g, "9");
	// sel = sel.replace(/𝟵/g, "{italicBoldReplacementKey-9}");
	// sel = sel.replace(/9/g, "𝟵");
	// sel = sel.replace(/{italicReplacementKey-9}/g, "9");
	// sel = sel.replace(/{italicBoldReplacementKey-9}/g, "9");
	// sel = sel.replace(/0/g, "{italicReplacementKey-0}");
	// sel = sel.replace(/0/g, "0");
	// sel = sel.replace(/𝟬/g, "{italicBoldReplacementKey-0}");
	// sel = sel.replace(/0/g, "𝟬");
	// sel = sel.replace(/{italicReplacementKey-0}/g, "0");
	// sel = sel.replace(/{italicBoldReplacementKey-0}/g, "0");

	sel = sel.replace(/A/g, "{italicReplacementKey-A}");
	sel = sel.replace(/𝘈/g, "A");
	sel = sel.replace(/𝗔/g, "{italicBoldReplacementKey-A}");
	sel = sel.replace(/𝘼/g, "𝗔");
	sel = sel.replace(/{italicReplacementKey-A}/g, "𝘈");
	sel = sel.replace(/{italicBoldReplacementKey-A}/g, "𝘼");
	// "Á": [
	// 	"𝗔́",
	// 	"𝘈́",
	// 	"𝘼́"
	// ],

	// sel = sel.replace(/á/g, "{normalReplacementKey-at}");
	// sel = sel.replace(/á/g, "{italicReplacementKey-at}");
	// // sel = sel.replace(/𝘢́/g, "á");
	// // sel = sel.replace(/𝗮́/g, "{boldItalicReplacementKey-at}");
	// // sel = sel.replace(/𝙖́/g, "𝘢́");
	// sel = sel.replace(/{italicReplacementKey-at}/g, "𝘢́");
	// // sel = sel.replace(/{boldItalicReplacementKey-at}/g, "𝙖́");
	// sel = sel.replace(/{normalReplacementKey-at}/g, "á");

	sel = sel.replace(/B/g, "{italicReplacementKey-B}");
	sel = sel.replace(/𝘉/g, "B");
	sel = sel.replace(/𝗕/g, "{italicBoldReplacementKey-B}");
	sel = sel.replace(/𝘽/g, "𝗕");
	sel = sel.replace(/{italicReplacementKey-B}/g, "𝘉");
	sel = sel.replace(/{italicBoldReplacementKey-B}/g, "𝘽");
	sel = sel.replace(/C/g, "{italicReplacementKey-C}");
	sel = sel.replace(/𝘊/g, "C");
	sel = sel.replace(/𝗖/g, "{italicBoldReplacementKey-C}");
	sel = sel.replace(/𝘾/g, "𝗖");
	sel = sel.replace(/{italicReplacementKey-C}/g, "𝘊");
	sel = sel.replace(/{italicBoldReplacementKey-C}/g, "𝘾");
	sel = sel.replace(/D/g, "{italicReplacementKey-D}");
	sel = sel.replace(/𝘋/g, "D");
	sel = sel.replace(/𝗗/g, "{italicBoldReplacementKey-D}");
	sel = sel.replace(/𝘿/g, "𝗗");
	sel = sel.replace(/{italicReplacementKey-D}/g, "𝘋");
	sel = sel.replace(/{italicBoldReplacementKey-D}/g, "𝘿");
	sel = sel.replace(/E/g, "{italicReplacementKey-E}");
	sel = sel.replace(/𝘌/g, "E");
	sel = sel.replace(/𝗘/g, "{italicBoldReplacementKey-E}");
	sel = sel.replace(/𝙀/g, "𝗘");
	sel = sel.replace(/{italicReplacementKey-E}/g, "𝘌");
	sel = sel.replace(/{italicBoldReplacementKey-E}/g, "𝙀");
	sel = sel.replace(/F/g, "{italicReplacementKey-F}");
	sel = sel.replace(/𝘍/g, "F");
	sel = sel.replace(/𝗙/g, "{italicBoldReplacementKey-F}");
	sel = sel.replace(/𝙁/g, "𝗙");
	sel = sel.replace(/{italicReplacementKey-F}/g, "𝘍");
	sel = sel.replace(/{italicBoldReplacementKey-F}/g, "𝙁");
	sel = sel.replace(/G/g, "{italicReplacementKey-G}");
	sel = sel.replace(/𝘎/g, "G");
	sel = sel.replace(/𝗚/g, "{italicBoldReplacementKey-G}");
	sel = sel.replace(/𝙂/g, "𝗚");
	sel = sel.replace(/{italicReplacementKey-G}/g, "𝘎");
	sel = sel.replace(/{italicBoldReplacementKey-G}/g, "𝙂");
	sel = sel.replace(/H/g, "{italicReplacementKey-H}");
	sel = sel.replace(/𝘏/g, "H");
	sel = sel.replace(/𝗛/g, "{italicBoldReplacementKey-H}");
	sel = sel.replace(/𝙃/g, "𝗛");
	sel = sel.replace(/{italicReplacementKey-H}/g, "𝘏");
	sel = sel.replace(/{italicBoldReplacementKey-H}/g, "𝙃");
	sel = sel.replace(/I/g, "{italicReplacementKey-I}");
	sel = sel.replace(/𝘐/g, "I");
	sel = sel.replace(/𝗜/g, "{italicBoldReplacementKey-I}");
	sel = sel.replace(/𝙄/g, "𝗜");
	sel = sel.replace(/{italicReplacementKey-I}/g, "𝘐");
	sel = sel.replace(/{italicBoldReplacementKey-I}/g, "𝙄");
	sel = sel.replace(/J/g, "{italicReplacementKey-J}");
	sel = sel.replace(/𝘑/g, "J");
	sel = sel.replace(/𝗝/g, "{italicBoldReplacementKey-J}");
	sel = sel.replace(/𝙅/g, "𝗝");
	sel = sel.replace(/{italicReplacementKey-J}/g, "𝘑");
	sel = sel.replace(/{italicBoldReplacementKey-J}/g, "𝙅");
	sel = sel.replace(/K/g, "{italicReplacementKey-K}");
	sel = sel.replace(/𝘒/g, "K");
	sel = sel.replace(/𝗞/g, "{italicBoldReplacementKey-K}");
	sel = sel.replace(/𝙆/g, "𝗞");
	sel = sel.replace(/{italicReplacementKey-K}/g, "𝘒");
	sel = sel.replace(/{italicBoldReplacementKey-K}/g, "𝙆");
	sel = sel.replace(/L/g, "{italicReplacementKey-L}");
	sel = sel.replace(/𝘓/g, "L");
	sel = sel.replace(/𝗟/g, "{italicBoldReplacementKey-L}");
	sel = sel.replace(/𝙇/g, "𝗟");
	sel = sel.replace(/{italicReplacementKey-L}/g, "𝘓");
	sel = sel.replace(/{italicBoldReplacementKey-L}/g, "𝙇");
	sel = sel.replace(/M/g, "{italicReplacementKey-M}");
	sel = sel.replace(/𝘔/g, "M");
	sel = sel.replace(/𝗠/g, "{italicBoldReplacementKey-M}");
	sel = sel.replace(/𝙈/g, "𝗠");
	sel = sel.replace(/{italicReplacementKey-M}/g, "𝘔");
	sel = sel.replace(/{italicBoldReplacementKey-M}/g, "𝙈");
	sel = sel.replace(/N/g, "{italicReplacementKey-N}");
	sel = sel.replace(/𝘕/g, "N");
	sel = sel.replace(/𝗡/g, "{italicBoldReplacementKey-N}");
	sel = sel.replace(/𝙉/g, "𝗡");
	sel = sel.replace(/{italicReplacementKey-N}/g, "𝘕");
	sel = sel.replace(/{italicBoldReplacementKey-N}/g, "𝙉");
	sel = sel.replace(/O/g, "{italicReplacementKey-O}");
	sel = sel.replace(/𝘖/g, "O");
	sel = sel.replace(/𝗢/g, "{italicBoldReplacementKey-O}");
	sel = sel.replace(/𝙊/g, "𝗢");
	sel = sel.replace(/{italicReplacementKey-O}/g, "𝘖");
	sel = sel.replace(/{italicBoldReplacementKey-O}/g, "𝙊");
	sel = sel.replace(/P/g, "{italicReplacementKey-P}");
	sel = sel.replace(/𝘗/g, "P");
	sel = sel.replace(/𝗣/g, "{italicBoldReplacementKey-P}");
	sel = sel.replace(/𝙋/g, "𝗣");
	sel = sel.replace(/{italicReplacementKey-P}/g, "𝘗");
	sel = sel.replace(/{italicBoldReplacementKey-P}/g, "𝙋");
	sel = sel.replace(/Q/g, "{italicReplacementKey-Q}");
	sel = sel.replace(/𝘘/g, "Q");
	sel = sel.replace(/𝗤/g, "{italicBoldReplacementKey-Q}");
	sel = sel.replace(/𝙌/g, "𝗤");
	sel = sel.replace(/{italicReplacementKey-Q}/g, "𝘘");
	sel = sel.replace(/{italicBoldReplacementKey-Q}/g, "𝙌");
	sel = sel.replace(/R/g, "{italicReplacementKey-R}");
	sel = sel.replace(/𝘙/g, "R");
	sel = sel.replace(/𝗥/g, "{italicBoldReplacementKey-R}");
	sel = sel.replace(/𝙍/g, "𝗥");
	sel = sel.replace(/{italicReplacementKey-R}/g, "𝘙");
	sel = sel.replace(/{italicBoldReplacementKey-R}/g, "𝙍");
	sel = sel.replace(/S/g, "{italicReplacementKey-S}");
	sel = sel.replace(/𝘚/g, "S");
	sel = sel.replace(/𝗦/g, "{italicBoldReplacementKey-S}");
	sel = sel.replace(/𝙎/g, "𝗦");
	sel = sel.replace(/{italicReplacementKey-S}/g, "𝘚");
	sel = sel.replace(/{italicBoldReplacementKey-S}/g, "𝙎");
	sel = sel.replace(/T/g, "{italicReplacementKey-T}");
	sel = sel.replace(/𝘛/g, "T");
	sel = sel.replace(/𝗧/g, "{italicBoldReplacementKey-T}");
	sel = sel.replace(/𝙏/g, "𝗧");
	sel = sel.replace(/{italicReplacementKey-T}/g, "𝘛");
	sel = sel.replace(/{italicBoldReplacementKey-T}/g, "𝙏");
	sel = sel.replace(/U/g, "{italicReplacementKey-U}");
	sel = sel.replace(/𝘜/g, "U");
	sel = sel.replace(/𝗨/g, "{italicBoldReplacementKey-U}");
	sel = sel.replace(/𝙐/g, "𝗨");
	sel = sel.replace(/{italicReplacementKey-U}/g, "𝘜");
	sel = sel.replace(/{italicBoldReplacementKey-U}/g, "𝙐");
	sel = sel.replace(/V/g, "{italicReplacementKey-V}");
	sel = sel.replace(/𝘝/g, "V");
	sel = sel.replace(/𝗩/g, "{italicBoldReplacementKey-V}");
	sel = sel.replace(/𝙑/g, "𝗩");
	sel = sel.replace(/{italicReplacementKey-V}/g, "𝘝");
	sel = sel.replace(/{italicBoldReplacementKey-V}/g, "𝙑");
	sel = sel.replace(/X/g, "{italicReplacementKey-X}");
	sel = sel.replace(/𝘟/g, "X");
	sel = sel.replace(/𝗫/g, "{italicBoldReplacementKey-X}");
	sel = sel.replace(/𝙓/g, "𝗫");
	sel = sel.replace(/{italicReplacementKey-X}/g, "𝘟");
	sel = sel.replace(/{italicBoldReplacementKey-X}/g, "𝙓");
	sel = sel.replace(/Y/g, "{italicReplacementKey-Y}");
	sel = sel.replace(/𝘠/g, "Y");
	sel = sel.replace(/𝗬/g, "{italicBoldReplacementKey-Y}");
	sel = sel.replace(/𝙔/g, "𝗬");
	sel = sel.replace(/{italicReplacementKey-Y}/g, "𝘠");
	sel = sel.replace(/{italicBoldReplacementKey-Y}/g, "𝙔");
	sel = sel.replace(/Z/g, "{italicReplacementKey-Z}");
	sel = sel.replace(/𝘡/g, "Z");
	sel = sel.replace(/𝗭/g, "{italicBoldReplacementKey-Z}");
	sel = sel.replace(/𝙕/g, "𝗭");
	sel = sel.replace(/{italicReplacementKey-Z}/g, "𝘡");
	sel = sel.replace(/{italicBoldReplacementKey-Z}/g, "𝙕");
	// ? === TILDES
	// * tilde A

	sel = sel.replace(/Á/g, "{normalReplacementKey-AT}");
	sel = sel.replace(/Á/g, "{italicReplacementKey-AT}");
	sel = sel.replace(/{italicReplacementKey-AT}/g, "𝘈́");
	// sel = sel.replace(/{boldItalicReplacementKey-at}/g, "𝙖́");
	sel = sel.replace(/{normalReplacementKey-AT}/g, "Á");
	//* Tilde E
	// sel = sel.replace(/Á/g, "{normalReplacementKey-AT}");
	sel = sel.replace(/É/g, "{italicReplacementKey-ET}");
	sel = sel.replace(/{italicReplacementKey-ET}/g, "𝘌́");
	// sel = sel.replace(/{boldItalicReplacementKey-at}/g, "𝙖́");
	sel = sel.replace(/{normalReplacementKey-ET}/g, "É");
	// * Tilde I
	// sel = sel.replace(/Á/g, "{normalReplacementKey-AT}");
	sel = sel.replace(/Í/g, "{italicReplacementKey-IT}");
	sel = sel.replace(/{italicReplacementKey-IT}/g, "𝘐́");
	// sel = sel.replace(/{boldItalicReplacementKey-at}/g, "𝙖́");
	sel = sel.replace(/{normalReplacementKey-IT}/g, "Í");

	// * Tilde O
	// sel = sel.replace(/Á/g, "{normalReplacementKey-AT}");
	sel = sel.replace(/Ó/g, "{italicReplacementKey-OT}");
	sel = sel.replace(/{italicReplacementKey-OT}/g, "𝘖́");
	// sel = sel.replace(/{boldItalicReplacementKey-at}/g, "𝙖́");
	sel = sel.replace(/{normalReplacementKey-OT}/g, "Ó");
	// * Tilde U
	// sel = sel.replace(/Á/g, "{normalReplacementKey-AT}");
	sel = sel.replace(/Ú/g, "{italicReplacementKey-UT}");
	sel = sel.replace(/{italicReplacementKey-UT}/g, "𝘜́");
	// sel = sel.replace(/{boldItalicReplacementKey-at}/g, "𝙖́");
	sel = sel.replace(/{normalReplacementKey-UT}/g, "Ú");


	// "Ú": [
	// 	"𝗨́",
	// 	"𝘜́",
	// 	"𝙐́"
	// ]



	// sel = sel.replace(/a/g, '{italicReplacementKey-a}');
	// sel = sel.replace(/𝘢/g, 'a');
	// sel = sel.replace(/{italicReplacementKey-a}/g, '𝘢');

	// sel = sel.replace(/b/g, '{italicReplacementKey-b}');
	// sel = sel.replace(/𝘣/g, 'b');
	// sel = sel.replace(/{italicReplacementKey-b}/g, '𝘣');

	// sel = sel.replace(/c/g, '{italicReplacementKey-c}');
	// sel = sel.replace(/𝘤/g, 'c');
	// sel = sel.replace(/{italicReplacementKey-c}/g, '𝘤');

	// sel = sel.replace(/d/g, '{italicReplacementKey-d}');
	// sel = sel.replace(/𝘥/g, 'd');
	// sel = sel.replace(/{italicReplacementKey-d}/g, '𝘥');

	// sel = sel.replace(/e/g, '{italicReplacementKey-e}');
	// sel = sel.replace(/𝘦/g, 'e');
	// sel = sel.replace(/{italicReplacementKey-e}/g, '𝘦');

	// sel = sel.replace(/f/g, '{italicReplacementKey-f}');
	// sel = sel.replace(/𝘧/g, 'f');
	// sel = sel.replace(/{italicReplacementKey-f}/g, '𝘧');

	// sel = sel.replace(/g/g, '{italicReplacementKey-g}');
	// sel = sel.replace(/𝘨/g, 'g');
	// sel = sel.replace(/{italicReplacementKey-g}/g, '𝘨');

	// sel = sel.replace(/h/g, '{italicReplacementKey-h}');
	// sel = sel.replace(/𝘩/g, 'h');
	// sel = sel.replace(/{italicReplacementKey-h}/g, '𝘩');

	// sel = sel.replace(/i/g, '{italicReplacementKey-i}');
	// sel = sel.replace(/𝘪/g, 'i');
	// sel = sel.replace(/{italicReplacementKey-i}/g, '𝘪');

	// sel = sel.replace(/j/g, '{italicReplacementKey-j}');
	// sel = sel.replace(/𝘫/g, 'j');
	// sel = sel.replace(/{italicReplacementKey-j}/g, '𝘫');

	// sel = sel.replace(/k/g, '{italicReplacementKey-k}');
	// sel = sel.replace(/𝘬/g, 'k');
	// sel = sel.replace(/{italicReplacementKey-k}/g, '𝘬');

	// sel = sel.replace(/l/g, '{italicReplacementKey-l}');
	// sel = sel.replace(/𝘭/g, 'l');
	// sel = sel.replace(/{italicReplacementKey-l}/g, '𝘭');

	// sel = sel.replace(/m/g, '{italicReplacementKey-m}');
	// sel = sel.replace(/𝘮/g, 'm');
	// sel = sel.replace(/{italicReplacementKey-m}/g, '𝘮');

	// sel = sel.replace(/n/g, '{italicReplacementKey-n}');
	// sel = sel.replace(/𝘯/g, 'n');
	// sel = sel.replace(/{italicReplacementKey-n}/g, '𝘯');

	// sel = sel.replace(/o/g, '{italicReplacementKey-o}');
	// sel = sel.replace(/𝘰/g, 'o');
	// sel = sel.replace(/{italicReplacementKey-o}/g, '𝘰');

	// sel = sel.replace(/p/g, '{italicReplacementKey-p}');
	// sel = sel.replace(/𝘱/g, 'p');
	// sel = sel.replace(/{italicReplacementKey-p}/g, '𝘱');

	// sel = sel.replace(/q/g, '{italicReplacementKey-q}');
	// sel = sel.replace(/𝘲/g, 'q');
	// sel = sel.replace(/{italicReplacementKey-q}/g, '𝘲');

	// sel = sel.replace(/r/g, '{italicReplacementKey-r}');
	// sel = sel.replace(/𝘳/g, 'r');
	// sel = sel.replace(/{italicReplacementKey-r}/g, '𝘳');

	// sel = sel.replace(/s/g, '{italicReplacementKey-s}');
	// sel = sel.replace(/𝘴/g, 's');
	// sel = sel.replace(/{italicReplacementKey-s}/g, '𝘴');

	// sel = sel.replace(/t/g, '{italicReplacementKey-t}');
	// sel = sel.replace(/𝘵/g, 't');
	// sel = sel.replace(/{italicReplacementKey-t}/g, '𝘵');

	// sel = sel.replace(/u/g, '{italicReplacementKey-u}');
	// sel = sel.replace(/𝘶/g, 'u');
	// sel = sel.replace(/{italicReplacementKey-u}/g, '𝘶');

	// sel = sel.replace(/v/g, '{italicReplacementKey-v}');
	// sel = sel.replace(/𝘷/g, 'v');
	// sel = sel.replace(/{italicReplacementKey-v}/g, '𝘷');

	// sel = sel.replace(/w/g, '{italicReplacementKey-w}');
	// sel = sel.replace(/𝘸/g, 'w');
	// sel = sel.replace(/{italicReplacementKey-w}/g, '𝘸');

	// sel = sel.replace(/x/g, '{italicReplacementKey-x}');
	// sel = sel.replace(/𝘹/g, 'x');
	// sel = sel.replace(/{italicReplacementKey-x}/g, '𝘹');

	// sel = sel.replace(/y/g, '{italicReplacementKey-y}');
	// sel = sel.replace(/𝘺/g, 'y');
	// sel = sel.replace(/{italicReplacementKey-y}/g, '𝘺');

	// sel = sel.replace(/z/g, '{italicReplacementKey-z}');
	// sel = sel.replace(/𝘻/g, 'z');
	// sel = sel.replace(/{italicReplacementKey-z}/g, '𝘻');

	// sel = sel.replace(/A/g, '{italicReplacementKey-A}');
	// sel = sel.replace(/𝘈/g, 'A');
	// sel = sel.replace(/{italicReplacementKey-A}/g, '𝘈');

	// sel = sel.replace(/B/g, '{italicReplacementKey-B}');
	// sel = sel.replace(/𝘉/g, 'B');
	// sel = sel.replace(/{italicReplacementKey-B}/g, '𝘉');

	// sel = sel.replace(/C/g, '{italicReplacementKey-C}');
	// sel = sel.replace(/𝘊/g, 'C');
	// sel = sel.replace(/{italicReplacementKey-C}/g, '𝘊');

	// sel = sel.replace(/D/g, '{italicReplacementKey-D}');
	// sel = sel.replace(/𝘋/g, 'D');
	// sel = sel.replace(/{italicReplacementKey-D}/g, '𝘋');

	// sel = sel.replace(/E/g, '{italicReplacementKey-E}');
	// sel = sel.replace(/𝘌/g, 'E');
	// sel = sel.replace(/{italicReplacementKey-E}/g, '𝘌');

	// sel = sel.replace(/F/g, '{italicReplacementKey-F}');
	// sel = sel.replace(/𝘍/g, 'F');
	// sel = sel.replace(/{italicReplacementKey-F}/g, '𝘍');

	// sel = sel.replace(/G/g, '{italicReplacementKey-G}');
	// sel = sel.replace(/𝘎/g, 'G');
	// sel = sel.replace(/{italicReplacementKey-G}/g, '𝘎');

	// sel = sel.replace(/H/g, '{italicReplacementKey-H}');
	// sel = sel.replace(/𝘏/g, 'H');
	// sel = sel.replace(/{italicReplacementKey-H}/g, '𝘏');

	// sel = sel.replace(/I/g, '{italicReplacementKey-I}');
	// sel = sel.replace(/𝘐/g, 'I');
	// sel = sel.replace(/{italicReplacementKey-I}/g, '𝘐');

	// sel = sel.replace(/J/g, '{italicReplacementKey-J}');
	// sel = sel.replace(/𝘑/g, 'J');
	// sel = sel.replace(/{italicReplacementKey-J}/g, '𝘑');

	// sel = sel.replace(/K/g, '{italicReplacementKey-K}');
	// sel = sel.replace(/𝘒/g, 'K');
	// sel = sel.replace(/{italicReplacementKey-K}/g, '𝘒');

	// sel = sel.replace(/L/g, '{italicReplacementKey-L}');
	// sel = sel.replace(/𝘓/g, 'L');
	// sel = sel.replace(/{italicReplacementKey-L}/g, '𝘓');

	// sel = sel.replace(/M/g, '{italicReplacementKey-M}');
	// sel = sel.replace(/𝘔/g, 'M');
	// sel = sel.replace(/{italicReplacementKey-M}/g, '𝘔');

	// sel = sel.replace(/N/g, '{italicReplacementKey-N}');
	// sel = sel.replace(/𝘕/g, 'N');
	// sel = sel.replace(/{italicReplacementKey-N}/g, '𝘕');

	// sel = sel.replace(/O/g, '{italicReplacementKey-O}');
	// sel = sel.replace(/𝘖/g, 'O');
	// sel = sel.replace(/{italicReplacementKey-O}/g, '𝘖');

	// sel = sel.replace(/P/g, '{italicReplacementKey-P}');
	// sel = sel.replace(/𝘗/g, 'P');
	// sel = sel.replace(/{italicReplacementKey-P}/g, '𝘗');

	// sel = sel.replace(/Q/g, '{italicReplacementKey-Q}');
	// sel = sel.replace(/𝘘/g, 'Q');
	// sel = sel.replace(/{italicReplacementKey-Q}/g, '𝘘');

	// sel = sel.replace(/R/g, '{italicReplacementKey-R}');
	// sel = sel.replace(/𝘙/g, 'R');
	// sel = sel.replace(/{italicReplacementKey-R}/g, '𝘙');

	// sel = sel.replace(/S/g, '{italicReplacementKey-S}');
	// sel = sel.replace(/𝘚/g, 'S');
	// sel = sel.replace(/{italicReplacementKey-S}/g, '𝘚');

	// sel = sel.replace(/T/g, '{italicReplacementKey-T}');
	// sel = sel.replace(/𝘛/g, 'T');
	// sel = sel.replace(/{italicReplacementKey-T}/g, '𝘛');

	// sel = sel.replace(/U/g, '{italicReplacementKey-U}');
	// sel = sel.replace(/𝘜/g, 'U');
	// sel = sel.replace(/{italicReplacementKey-U}/g, '𝘜');

	// sel = sel.replace(/V/g, '{italicReplacementKey-V}');
	// sel = sel.replace(/𝘝/g, 'V');
	// sel = sel.replace(/{italicReplacementKey-V}/g, '𝘝');

	// sel = sel.replace(/W/g, '{italicReplacementKey-W}');
	// sel = sel.replace(/𝘞/g, 'W');
	// sel = sel.replace(/{italicReplacementKey-W}/g, '𝘞');

	// sel = sel.replace(/X/g, '{italicReplacementKey-X}');
	// sel = sel.replace(/𝘟/g, 'X');
	// sel = sel.replace(/{italicReplacementKey-X}/g, '𝘟');

	// sel = sel.replace(/Y/g, '{italicReplacementKey-Y}');
	// sel = sel.replace(/𝘠/g, 'Y');
	// sel = sel.replace(/{italicReplacementKey-Y}/g, '𝘠');

	// sel = sel.replace(/Z/g, '{italicReplacementKey-Z}');
	// sel = sel.replace(/𝘡/g, 'Z');
	// sel = sel.replace(/{italicReplacementKey-Z}/g, '𝘡');

	// sel = sel.replace(/0/g, '{italicReplacementKey-0}');
	// sel = sel.replace(/𝟶/g, '0');
	// sel = sel.replace(/{italicReplacementKey-0}/g, '𝟶');

	// sel = sel.replace(/1/g, '{italicReplacementKey-1}');
	// sel = sel.replace(/𝟷/g, '1');
	// sel = sel.replace(/{italicReplacementKey-1}/g, '𝟷');

	// sel = sel.replace(/2/g, '{italicReplacementKey-2}');
	// sel = sel.replace(/𝟸/g, '2');
	// sel = sel.replace(/{italicReplacementKey-2}/g, '𝟸');

	// sel = sel.replace(/3/g, '{italicReplacementKey-3}');
	// sel = sel.replace(/𝟹/g, '3');
	// sel = sel.replace(/{italicReplacementKey-3}/g, '𝟹');

	// sel = sel.replace(/4/g, '{italicReplacementKey-4}');
	// sel = sel.replace(/𝟺/g, '4');
	// sel = sel.replace(/{italicReplacementKey-4}/g, '𝟺');

	// sel = sel.replace(/5/g, '{italicReplacementKey-5}');
	// sel = sel.replace(/𝟻/g, '5');
	// sel = sel.replace(/{italicReplacementKey-5}/g, '𝟻');

	// sel = sel.replace(/6/g, '{italicReplacementKey-6}');
	// sel = sel.replace(/𝟼/g, '6');
	// sel = sel.replace(/{italicReplacementKey-6}/g, '𝟼');

	// sel = sel.replace(/7/g, '{italicReplacementKey-7}');
	// sel = sel.replace(/𝟽/g, '7');
	// sel = sel.replace(/{italicReplacementKey-7}/g, '𝟽');

	// sel = sel.replace(/8/g, '{italicReplacementKey-8}');
	// sel = sel.replace(/𝟾/g, '8');
	// sel = sel.replace(/{italicReplacementKey-8}/g, '𝟾');

	// sel = sel.replace(/9/g, '{italicReplacementKey-9}');
	// sel = sel.replace(/𝟿/g, '9');
	// sel = sel.replace(/{italicReplacementKey-9}/g, '𝟿');
	return sel;
}



export const setTaskLocalStorage = (hashtag) => {
	let hastags;
	if (localStorage.getItem('hastags_space') === null) {
		hastags = [];
	} else {
		hastags = JSON.parse(localStorage.getItem('hastags_space'));
	}
	hastags.push(hashtag);

	localStorage.setItem('hastags_space', JSON.stringify(hastags));
	let news = hastags.filter(i => i.projectId === hashtag.projectId);
	return news.reverse();
}

export const getAllHashtags = () => {
	let hashtags;
	if (localStorage.getItem('hastags_space') === null) {
		hashtags = [];
	} else {
		hashtags = JSON.parse(localStorage.getItem('hastags_space'));
	}
	return hashtags;
}

export const getHastags = (id) => {
	let hashtags;
	if (localStorage.getItem('hastags_space') === null) {
		hashtags = [];
	} else {
		hashtags = JSON.parse(localStorage.getItem('hastags_space'));
	}
	let news = hashtags.filter(i => i.projectId === id);
	return news.reverse();


}